module.exports = __webpack_public_path__ + "img/efd08fb.png";